import isEmail from 'validator/lib/isEmail';
import { UserLevel } from '../constants';
import { IAuthUser, IUser, IUserWithEmail } from '../schemas/user';

export function isUserWithEmail(user: IUser): user is IUserWithEmail {
  if (user.email) return isEmail(user.email);
  return false;
}

export function isAuthUser(user: IUser): user is IAuthUser {
  return user.level !== UserLevel.anonymous && isUserWithEmail(user) && !!user.username;
}

export function isAnonymousUser(user: Pick<IUser, 'level'>) {
  return user.level === UserLevel.anonymous;
}
